export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
  'component.exportResult.success': '导出完成 ✓',
  'component.exportResult.processedCount': '处理数据：{count} 条',
  'component.exportResult.filename': '文件名称：{filename}',
  'component.exportResult.fileSize': '文件大小：{size}',
  'component.exportResult.unknown': '未知',
};
